import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { Filter, PaginationPage, PaginationResponse } from "src/app/classes";
import { Issue } from "../issue/classes";
import { Offer } from "../offer/classes";
import { DoubletSuggestion } from "./classes";

export const CONCURRENCY_PROVIDER_SERVICE = new InjectionToken<IConcurrencyProviderService>('CONCURRENCY_PROVIDER_SERVICE');

export interface IConcurrencyProviderService {
    checkingVersion$: Observable<boolean>;
    concurrencyStamp$: Observable<string>;
    entityIdentifier$: Observable<any>;
    validStamp$: Observable<boolean>;
}

export const DOUBLET_PROVIDER_SERVICE = new InjectionToken<IDoubletProviderService>('DOUBLET_PROVIDER_SERVICE');

export interface IDoubletProviderService {
    checkerVisible$: Observable<boolean>;
    doublets$: Observable<PaginationResponse<DoubletSuggestion[]>>;
    doubletClick: (doublet: DoubletSuggestion) => void;
    doubletClicked$: Observable<DoubletSuggestion>;
    setDoubletCheckerVisible(value: boolean): void;
    setSearchString(search: string): void;
    setSearchFilter(filter: Filter, page: PaginationPage): void;
}

export const ISSUES_PROVIDER_SERVICE = new InjectionToken<IIssuesProvider>('ISSUES_PROVIDER_SERVICE');

export interface IIssuesProvider {
    issues$: Observable<Issue[]>;
    visibleIssueTypes$: Observable<{ 'issues': boolean, 'incidents': boolean, 'changes': boolean, 'projects': boolean }>;
    visibleIssues$: Observable<Issue[]>;
    issueCount$: Observable<number>;
    incidentCount$: Observable<number>;
    projectCount$: Observable<number>;
    changeCount$: Observable<number>;
    setVisibleIssueTypes(types: { 'issues': boolean, 'incidents': boolean, 'changes': boolean, 'projects': boolean }): void;
}

export const OFFER_PROVIDER_SERVICE = new InjectionToken<IOfferProviderService>('OFFER_PROVIDER_SERVICE');

export interface IOfferProviderService {
    offer$: Observable<Offer>;
    offerId$: Observable<number>;
}

export const OFFERS_PROVIDER_SERVICE = new InjectionToken<IOffersProviderService>('OFFERS_PROVIDER_SERVICE');

export interface IOffersProviderService {
    offers$: Observable<Offer[]>;
}
